import {
    FETCH_DEPARTMENTS_REQUEST, FETCH_DEPARTMENTS_SUCCESS, FETCH_DEPARTMENTS_FAILURE,
    CREATE_DEPARTMENT_SUCCESS, UPDATE_DEPARTMENT_SUCCESS, DELETE_DEPARTMENT_SUCCESS
  } from '../actions/departmentActions';
  
  const initialState = {
    departments: [],
    loading: false,
    error: null,
  };
  
  export default function departmentReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_DEPARTMENTS_REQUEST:
        return { ...state, loading: true };
      case FETCH_DEPARTMENTS_SUCCESS:
        return { ...state, loading: false, departments: action.payload };
      case CREATE_DEPARTMENT_SUCCESS:
        return { ...state, departments: [...state.departments, action.payload] };
      case UPDATE_DEPARTMENT_SUCCESS:
        return {
          ...state,
          departments: state.departments.map((dept) =>
            dept.id === action.payload.id ? action.payload : dept
          ),
        };
      case DELETE_DEPARTMENT_SUCCESS:
        return {
          ...state,
          departments: state.departments.filter((dept) => dept.id !== action.payload),
        };
      default:
        return state;
    }
  }
  